import Select from "../../../../form/Select";
import React from "react";
import {optionsTemplate} from "../../../../../utils/formatters";
import debounce from "../../../../../utils/debounce";

export class Target extends React.Component {

    constructor(props) {
        super(props);
        this.change = debounce((field, value) => {
            props.setFieldValue && props.setFieldValue(field, value);
        }, 300);
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        const propsTop = {...this.props};
        const {props} = propsTop;
        const prevPropsTop = {...prevProps};
        const pProps = prevPropsTop.props;
        if (props.values.id + "" === "" + pProps?.id && props.values.customer?.partner_id + "" !== "" + pProps.values.customer?.partner_id) {
            this.change("target", null);
        }
    }

    render() {
        const propsTop = {...this.props};
        const {props, state, parent} = propsTop;
        const {hidden, labels} = props;
        const targetProps = props.getProps("target");
        return (hidden || []).indexOf("target") === -1 && (!!props.values.customer || this.props.visible) ? <Select
            label={labels.target || "Hova"}
            name="target"
            component="location"
            objectValue={true}
            autoSelect={true}
            labelKey="name"
            storeType="local"
            isClearable={propsTop.isClearable}
            filter={props.values.customer ? {field: "partner", value: props.values.customer.partner_id} : null}
            optionsTemplate={optionsTemplate("location")}
            {...targetProps}
            value={props.getValue("target")}
            disabled={targetProps.disabled || propsTop.disabled}
            saveChanges={props.setFieldValue}
        /> : null;
    }
}

export default Target;